import {AxiosResponse} from "axios";
import Api from "./api";

export default class ObjectService {
    // Объекты
    static async create(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/objects/create', fields);
    }

    static async query(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/objects/query', fields);
    }

    static async update(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/objects/update', fields);
    }

    static async delete(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/objects/delete', fields);
    }

    // Анкеты объектов
    static async createAnketa(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/objects/create_anketa', fields);
    }

    static async queryAnketa(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/objects/query_anketa', fields);
    }

    static async updateAnketa(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/objects/update_anketa', fields);
    }

    static async deleteAnketa(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/objects/delete_anketa', fields);
    }
}